import { ResultOf } from 'gql.tada';
import { gql } from '../../gql';

export const GET_MODEL_IDS = gql(`
  query GetModelIds(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    backflowAssemblyModels(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
      groupBy: ["id"]
    ) {
      id
    }
  }
`);

export const GET_MODELS = gql(`
  query GetModels(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    backflowAssemblyModels(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
    ) {
      id
      name
      visible
      backflowAssemblyMakeId
      backflowAssemblyMake {
        id
        name
      }
    }
  }
`);

export type ModelItem = ResultOf<
  typeof GET_MODELS
>['backflowAssemblyModels'][number];
